import Vue from 'vue';
import FetchLoading from './index.vue';
import { Consts } from '@/libs/interfaces';

const LoadingConstructor = Vue.extend(FetchLoading);
const getAnintance = () => new LoadingConstructor({
  el: document.createElement('div'),
});
const intance = getAnintance();
LoadingConstructor.prototype.open = (payload) => {
  Vue.nextTick(() => {
    let option = {};
    if (typeof payload === 'string' || !payload) {
      option.wrapper = '#app';
      option.imgEl = payload || 'icon3';
    } else {
      option = payload;
    }
    option.wrapper = option.wrapper || '#app';
    const parentEl = document.querySelector(option.wrapper);
    if (!parentEl) return;
    intance.imgEl = option.imgEl;
    intance.loadingStyle = option.loadingStyle;
    parentEl.style.position = 'relative';
    parentEl.appendChild(intance.$el);
    if (option.imgEl === Consts.ORDER_SUCCESS) {
      setTimeout(() => {
        intance.close();
      }, 1500);
    }
  });
};
LoadingConstructor.prototype.close = () => {
  const fetchLoadingEl = document.querySelector('#fectchLoading');
  if (fetchLoadingEl) {
    fetchLoadingEl.remove();
  }
};
export default intance;
